import { useStore as _useStore } from '@nuxtjs/composition-api'
import { type Store } from 'vuex/types'

export const useStore = <S>(): Store<S> => {
  const store = _useStore()
  return store as unknown as Store<S>
}
